import { api } from "./api";

export const createUserService = async (data: ICreateLoginDTO) => {
  const response2 = await api.post("/register", { data });
  return response2.data;
};
